export const normalizeSongTitle = (title: string): string => {
  if (!title) return '';
  
  // First, normalize to lowercase and trim whitespace
  let normalized = title.toLowerCase().trim()
    // Remove apostrophes FIRST
    .replace(/'/g, '')
    // Normalize common word endings (now without apostrophe)
    .replace(/in\b/g, 'ing') // Looking for 'in' at end of word
    // Normalize featuring variations
    .replace(/\s+feat\.?\s+/g, ' featuring ')
    .replace(/\s+ft\.?\s+/g, ' featuring ')
    // Ensure consistent spacing around "featuring"
    .replace(/\s+featuring\s+/g, ' featuring ')
    // Convert & to "featuring" consistently
    .replace(/\s+&\s+/g, ' featuring ')
    // Remove periods from common abbreviations AFTER feat normalization
    .replace(/\b(mr|mrs|ms|dr|jr|sr|vol|vs)\./gi, '$1')
    // Remove parentheses but keep their content
    .replace(/\(([^)]*)\)/g, ' $1 ')
    // Remove remaining special characters and extra spaces
    .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\[\]]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return normalized;
};

export const normalizeSongArtistKey = (song: string, artist: string): string => {
  const normalizedSong = normalizeSongTitle(song);
  const normalizedArtist = normalizeSongTitle(artist);
  
  if (!normalizedSong && !normalizedArtist) return '';
  if (!normalizedSong) return normalizedArtist;
  if (!normalizedArtist) return normalizedSong;
  
  // Create the combined key using song and artist
  const key = `${normalizedSong} - ${normalizedArtist}`;
  
  // Log for debugging if the result feels unexpected
  if ((song && artist) && (!normalizedSong || !normalizedArtist)) {
    console.warn(`[normalizeSongArtistKey] Unexpected normalization result:`, {
      originalSong: song,
      originalArtist: artist,
      normalizedSong,
      normalizedArtist,
      key
    });
  }
  
  return key;
}; 